import React from 'react';

import PropTypes from 'prop-types';

// Components
import { Mui } from 'components';

function Message({
  children,
  open,
  loading,
  title,
  onClose,
  disabled,
  onConfirm,
  disableActions,
  disableTypography,
  typographyProps,
  maxWidth = 'sm',
  fullWidth = true,
}) {
  return (
    <Mui.Dialog open={open} onClose={onClose} maxWidth={maxWidth} fullWidth={fullWidth}>
      <Mui.DialogTitle>
        <Mui.Box display="flex" alignItems="center" justifyContent="space-between">
          <Mui.Typography variant="h5">{title}</Mui.Typography>
          {!!onClose && (
            <Mui.Tooltip title="Fechar">
              <Mui.IconButton onClick={onClose}>
                <Mui.Icon>close</Mui.Icon>
              </Mui.IconButton>
            </Mui.Tooltip>
          )}
        </Mui.Box>
      </Mui.DialogTitle>
      <Mui.DialogContent>
        {disableTypography ? (
          children
        ) : (
          <Mui.DialogContentText color="textPrimary" {...typographyProps}>
            {children}
          </Mui.DialogContentText>
        )}
      </Mui.DialogContent>
      {!disableActions && (
        <Mui.DialogActions>
          <Mui.Box
            px={1}
            width="100%"
            display="flex"
            alignContent="center"
            alignItems="center"
            justifyContent="space-between">
            {!!onConfirm && (
              <Mui.Button
                size="large"
                color="primary"
                variant="text"
                disabled={disabled}
                onClick={onConfirm}
                loading={loading}>
                Confirmar
              </Mui.Button>
            )}
            {!!onClose && (
              <Mui.Button
                size="large"
                color="secondary"
                variant="text"
                disabled={loading}
                onClick={onClose}>
                Fechar
              </Mui.Button>
            )}
          </Mui.Box>
        </Mui.DialogActions>
      )}
    </Mui.Dialog>
  );
}

Message.propTypes = {
  children: PropTypes.any,
  open: PropTypes.bool,
  disabled: PropTypes.bool,
  loading: PropTypes.bool,
  disableActions: PropTypes.bool,
  disableTypography: PropTypes.bool,
  onClose: PropTypes.func,
  onConfirm: PropTypes.func,
  title: PropTypes.any,
  typographyProps: PropTypes.object,
  maxWidth: PropTypes.oneOf(['xs', 'sm', 'md', 'lg', 'xl', false]),
  fullWidth: PropTypes.bool,
};

export default Message;
